<!-- for refactoring - use one component to be used in CompanyAttendance and TeamAttendance
component already exist, just need to update to latest -->
<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elavation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to previous page" @click="$router.push('/myteam')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <help-link appId="attendance" pageId="team-attendance" color="white"></help-link>
                    <v-btn-toggle v-model="toggle_view">
                        <v-btn small class="primary white--text" title="Daily View">
                            Daily
                        </v-btn>
                        <v-btn small @click="viewWeekly" title="Click to view Weekly Attedance">
                            Weekly
                        </v-btn>
                    </v-btn-toggle> 
                </v-toolbar>
            </v-card>
            <v-alert v-if="error" :value="true" color="error" icon="error" outline>
                {{errorMessage}}
            </v-alert>  
            <v-layout row wrap style="margin-top:5px">        
                <v-flex xs12> 
                    <v-card class="elavation-1">
                        <v-toolbar flat height="40px">
                            <div class="wp-30 mb-10">
                                <v-text-field v-model="search" append-icon="search" label="Search employee name" single-line hide-details></v-text-field>
                            </div>
                            <v-spacer></v-spacer>  
                            <v-btn icon title="View Previous Day"  @click="viewPrevious" style="margin-right:10px;">
                                <v-icon>chevron_left</v-icon>
                            </v-btn>
                            <b>{{dateDescription}}</b>
                            <v-btn icon title="View Next Day" @click="viewNext">
                                <v-icon>chevron_right</v-icon>
                            </v-btn>                             
                        </v-toolbar>
                        <v-data-table
                            :headers="headers"
                            :items="teamAtteandanceFiltered"
                            :loading="loading"
                            :rows-per-page-items="rowsPerPageItems"
                            :pagination.sync="paginationSync"
                        >
                            <v-progress-linear v-slot:progress color="primary" indeterminate></v-progress-linear>
                            <template v-slot:items="props">
                                <tr>
                                    <td>
                                        <v-chip style="margin-left:-5px;">
                                            <v-avatar>
                                                <v-img :src="awsS3Helper.getAvatarUrl(props.item.userId)"></v-img>
                                            </v-avatar>
                                            <b>{{props.item.firstName}} {{props.item.lastName}}</b>
                                        </v-chip>
                                    </td>
                                    <td>
                                        <v-chip v-if="props.item.workShift" :style="`background-color:${props.item.workShiftColor}; margin-left:-5px;`" :title="props.item.workShift">
                                            {{$moment(props.item.clockStart).format('hh:mma')}}-{{$moment(props.item.clockEnd).format('hh:mma')}}
                                        </v-chip>
                                        <span v-else>None</span>
                                    </td>
                                    <td>{{ props.item.clockIn | moment("hh:mma") }}</td>
                                    <td style="padding:3px 0px 3px 10px;">
                                        <v-img v-if="props.item.clockIn && !props.item.uploaded" :src="commonfn.getAttendanceThumbPicUrl(props.item.userId, $moment(props.item.transDate).format('YYYY-MM-DD'), 'ClockIn')" height="50" width="50" @click="showPicViewer(props.item, 'ClockIn')" style="cursor:pointer;border-radius:6px;"></v-img>  
                                    </td>
                                    <td>{{ props.item.clockInDevice }}</td>
                                    <td>{{ props.item.clockOut | moment("hh:mma") }}</td>
                                    <td style="padding:3px 0px 3px 10px;">
                                        <v-img v-if="props.item.clockOut && !props.item.uploaded" :src="commonfn.getAttendanceThumbPicUrl(props.item.userId, $moment(props.item.transDate).format('YYYY-MM-DD'), 'ClockOut')" height="50" width="50" @click="showPicViewer(props.item, 'ClockIn')" style="cursor:pointer;border-radius:6px;"></v-img> 
                                    </td>
                                    <td>{{ props.item.clockOutDevice }}</td>
                                </tr>
                            </template>
                        </v-data-table> 
                    </v-card>
                </v-flex>
            </v-layout>
        </v-flex>
  
        <v-dialog v-model="dialogPicViewer" fullscreen hide-overlay transition="dialog-bottom-transition">  
            <pic-viewer ref="picViewerRef" :dialogPicViewer.sync="dialogPicViewer"></pic-viewer>
        </v-dialog>
    </v-layout>  
</template>
<script>
import teamApi from '@/api/team'
import commonfn from '@/common/functions'   //for refactor
import awsS3Helper from '@/helpers/aws-s3'
import userPrefs from '@/helpers/user-prefs'
import rowsPerPageItems from '@/constants/rows-per-page'

export default {    
    name: 'MyTeamAttendance',
    metaInfo: {
        title: 'My Team Attendance',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: "View my team's daily attendance, clock-in/clock-out, device used, location, picture" },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
            ]
    }, 
    components: {
        'help-link': () => import('@/components/Common/HelpLink'),
        'pic-viewer': () => import('@/components/Attendance/AttendancePicViewer')
    },   
    props: ['teamId', 'pageKey'],
    data () {
        const routeName = this.$route.name
        const savedSort = userPrefs.getSort(routeName)

        return {
            commonfn,
            awsS3Helper,
            userPrefs,
            rowsPerPageItems,
            paginationSync: {
                rowsPerPage: userPrefs.getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            search: userPrefs.getSearchKeyword(routeName),
            error: false,
            errorMessage: '',
            loading: false,
            transDate: null,
            teamAtteandance: [],
            toggle_view: 0,
            headers: [
                {text: 'Employee',align: 'left',value: 'lastName',width: '10%', sortable:true},
                {text: 'Shift',align: 'left',value: 'clockStart',width: '5%', sortable:true},
                {text: 'Clock-In',align: 'left',value: 'clockIn',width: '10%', sortable:true},
                {text: 'Pic',align: 'left',value: '',width: '10%', sortable:false},
                {text: 'Device',align: 'left',value: 'clockInDevice',width: '10%', sortable:true},
                {text: 'Clock-Out',align: 'left',value: 'clockOut',width: '10%', sortable:true},
                {text: 'Pic',align: 'left',value: 'hours',width: '10%', sortable:false},
                {text: 'Device',align: 'left',value: 'clockOutDevice',width: '10%', sortable:true}
            ],
            dialogPicViewer: false
        }
    },
    methods: {  
        viewWeekly() {
            const weekNo = this.$moment().week()
            this.$router.push(`/myteam/attendance/weekly/${weekNo}`)
        },
        viewPrevious() {
            this.transDate =  this.$moment(this.transDate).add(-1, 'days').format("YYYY-MM-DD")
            this.$router.push(`/myteam/attendance/${this.transDate}`)
            this.getAttendanceStatus()
        },
        viewNext() {
            this.transDate = this.$moment(this.transDate).add(1, 'days').format("YYYY-MM-DD")
            this.$router.push(`/myteam/attendance/${this.transDate}`)
            this.getAttendanceStatus()
        },
        showPicViewer(data, action) {
            this.$refs.picViewerRef.viewAttenancePic(data, action)
            this.dialogPicViewer = true
        },
        async getAttendanceStatus() {
            try {
                this.loading = true
                const transDate = this.$moment(this.transDate).format('YYYY-MM-DD')
                const teamId = this.$store.state.selectedTeamId
                const response = await teamApi.getTeamStatusByDate(teamId, transDate)
                if (response && response.status == 200) {            
                    this.teamAtteandance = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    created() {
        this.transDate = new Date()

         //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: `${this.$store.state.selectedTeamName} Attendance`
        })
        
        if (this.$route.params.transDate) {
            this.transDate = this.$route.params.transDate
        }

        this.getAttendanceStatus()
    },
    watch: {
       'paginationSync.rowsPerPage'(newVal) {
            userPrefs.updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            userPrefs.updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            userPrefs.updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        },
        search(newVal) {
            userPrefs.updateSearchKeyword(this.$route.name, newVal)
        }
    },
    computed: {
        teamAtteandanceFiltered() {
            var temp = this.teamAtteandance

            //search handler
            if (this.search) {
                temp = temp.filter(item => {
                    return ( item.firstName.toLowerCase().includes(this.search.toLowerCase()) || item.lastName.toLowerCase().includes(this.search.toLowerCase()))
                })
            }
            return temp
        },
        currentDate() {
            return this.$moment(this.transDate).format("YYYY-MM-DD") == this.$moment(new Date()).format("YYYY-MM-DD")              
        },
        dateDescription() {
            if (this.currentDate) return `${this.$moment(this.transDate).format("ddd, MMM DD")} (Today)`
            return this.$moment(this.transDate).format("ddd, MMM DD")
        }
    },
}
</script>